module.exports = __webpack_public_path__ + "static/media/delete-account-trash.2ddd816d.svg";